import { FilterAltOutlined, FilterAltRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useMemo } from "react";

const AdvancedTableFilteringButton = ({
  advancedFiltering,
  setAdvancedFiltering,
  sx,
}) => {
  const styles = useMemo(() => {
    return {
      background: advancedFiltering ? "#e3f2fd" : "inherit",
      ...sx,
    };
  }, [advancedFiltering, sx]);
  return (
    <Tooltip
      title={
        !advancedFiltering
          ? "Show Advanced Filtering"
          : "Hide Advanced Filtering"
      }
    >
      <IconButton
        color={advancedFiltering ? "primary" : "default"}
        onClick={() => setAdvancedFiltering((s) => !s)}
        size="small"
        sx={styles}
      >
        {advancedFiltering ? <FilterAltRounded /> : <FilterAltOutlined />}
      </IconButton>
    </Tooltip>
  );
};

export default AdvancedTableFilteringButton;
